import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import colors from 'constants/colors';

const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) =>
    prop !== 'top' && prop !== 'right' && prop !== 'mobile',
})(({ top, right, mobile }) => ({
  position: 'relative',
  userSelect: 'none',
  cursor: 'pointer',

  '& .MuiBadge-badge': {
    position: 'absolute',
    top: top ?? '10px',
    right: right ?? '10px',
    zIndex: 'auto',
    width: 11,
    height: 11,
    background: colors.red,
    borderRadius: 11,

    ...(mobile && {
      '@media (min-width: 767px) and (max-width: 1200px)': {
        width: 16,
        height: 16,
        borderRadius: 16,
      },
      '@media (max-width: 767px)': {
        width: 10,
        height: 10,
        borderRadius: 10,
      },
    }),
  },

  '& .MuiBadge-invisible': {
    display: 'none',
  },
}));

export default StyledBadge;